import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

/**
 * 生成随机AES密钥（256位）
 */
export function generateAesKey() {
  return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Base64)
}

/**
 * RSA公钥加密
 * @param data 明文
 * @param publicKey RSA公钥（Base64编码）
 */
export function rsaEncrypt(data, publicKey) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  const encrypted = encrypt.encrypt(data)
  if (encrypted === false) {
    throw new Error('RSA加密失败')
  }
  return encrypted
}

/**
 * AES加密
 * @param data 明文
 * @param aesKey AES密钥（Base64编码）
 */
export function aesEncrypt(data, aesKey) {
  const key = CryptoJS.enc.Base64.parse(aesKey)
  const iv = CryptoJS.enc.Utf8.parse('0000000000000000')
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

/**
 * AES解密
 * @param encryptedData Base64编码的密文
 * @param aesKey AES密钥（Base64编码）
 */
export function aesDecrypt(encryptedData, aesKey) {
  const key = CryptoJS.enc.Base64.parse(aesKey)
  const iv = CryptoJS.enc.Utf8.parse('0000000000000000')
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
